import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["codeblock", "item"]

  toggle(e) {
    e.preventDefault()
    e.stopPropagation()
    const activeBlock = document.getElementById(`${e.currentTarget.getAttribute("aria-controls")}`)

    // Switch the active tab
    this.itemTargets.forEach((element) => {
      element.parentNode.setAttribute("aria-expanded", "false")
    })

    e.currentTarget.parentNode.setAttribute("aria-expanded", "true")

    // Switch the visible codeblock
    this.codeblockTargets.forEach((element) => {
      element.classList.add("d-none")
    })

    activeBlock.classList.remove("d-none")
  }
}
